import React from 'react'
import PropTypes from 'prop-types'
import {TextInput, Dropdown} from '@/components/atoms'
import styles from '../../../RewardSetup.module.scss'
import { preventInvalidNumericInput } from '@/utils/inputValidations'
import {useAppSelector} from '@/store'
import {getCurrencySymbol} from '@/utils/commons'

/**
 * BonusProductsCondition component displays the bonus products reward condition UI
 * Handles product selection via modal triggered by dropdown option selection, order quantity, and bonus product limit inputs
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing selectedProducts, orderQuantity, bonusProductLimit
 * @param {Object} props.validation - Validation state object
 */
const VisaCard = ({
    formData,
    validation,
    rewardCardTypes,
    rewardCardTypesLoading,
    handleRedeemPointsChange,
    handleRewardCardTypeChange,
    handleRewardCashAmountChange,
    redeemPointsError,
    rewardCashAmountError,
}) => {
  
  const selectedOptions = formData.rewardCardType ? rewardCardTypes.filter(rt => rt.value === formData.rewardCardType) : []
  const countryCode = useAppSelector(state => state.countryCode).countryCode
  const currencySymbol = getCurrencySymbol(countryCode)
  
  return (
    <div className="flex flex-wrap gap-[13px]">
      <div className={`${styles.rewardSetup__cardTypeDropdownWrapper} text-left`}>
        <Dropdown
          className='placeholder:text-sm text-sm'
          value={selectedOptions} // Show selected products
          isError={validation.rewardCardTypeValid}
          errorMessage={validation.rewardCardTypeValid ? 'At least one type must be selected' : ''}
          isDark={true}
          childList={rewardCardTypes}
          placeholder={rewardCardTypesLoading ? "Loading..." : "Card Type"}
          isJsonWrap={false}
          selection='single'
          hideMenuListOnSelection={true}
          isClearable={false}
          updateValue={handleRewardCardTypeChange}
          style={{maxWidth: '180px'}}
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">{currencySymbol}</span>
      <div className={`${styles.rewardSetup__visaCardInputPoints }`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.rewardCashAmount}
          onChange={handleRewardCashAmountChange}
          label=""
          placeholderText="Value"
          error={rewardCashAmountError}
          isDark={true}
          type="number"
          handleKeyDown={preventInvalidNumericInput}
          id="reward-cash-amount"
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">by redeeeming</span>
      <div className={`${styles.rewardSetup__visaCardInputPoints }`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.redeemPoints}
          onChange={handleRedeemPointsChange}
          label=""
          placeholderText="Points"
          error={redeemPointsError}
          isDark={true}
          handleKeyDown={preventInvalidNumericInput}
          type="number"
          id="redeem-points"
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">points.</span>

    </div>
  )
}

VisaCard.propTypes = {
  formData: PropTypes.shape({
    redeemPoints: PropTypes.string,
    rewardCashAmount: PropTypes.string,
    rewardCardType: PropTypes.string,
  }).isRequired,
  rewardCardTypesLoading: PropTypes.bool.isRequired,
  handleRedeemPointsChange: PropTypes.func.isRequired,
  handleRewardCardTypeChange: PropTypes.func.isRequired,
  handleRewardCashAmountChange: PropTypes.func.isRequired,
  redeemPointsError: PropTypes.string,
  rewardCardTypeError: PropTypes.string,
  rewardCashAmountError: PropTypes.string,
}

export default VisaCard
